import { render, staticRenderFns } from "./telemetry-config-datapoint.vue?vue&type=template&id=960afd1e&scoped=true&"
import script from "./telemetry-config-datapoint.vue?vue&type=script&lang=ts&"
export * from "./telemetry-config-datapoint.vue?vue&type=script&lang=ts&"
import style0 from "./telemetry-config-datapoint.vue?vue&type=style&index=0&id=960afd1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960afd1e",
  null
  
)

export default component.exports